<template>
    <div>
        <b-card>
            <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="mr-2">Pencarian</div>
                <b-form-select v-model="filter.mode" :options="optMode" @input="getItems(1)" />
            </div>
            <div v-if="filter.mode == 0" class="d-flex align-items-center justify-content-between mb-3">
                <div class="mr-2">Filter</div>
                <b-form-input class="mr-2"
                    v-model="filter.sn"
                    type="search"
                    id="filterInput"
                    placeholder="SN"
                    @keyup.enter="getItems"
                />
                <b-form-select v-model="filter.status" :options="optStatus" class="mr-2">
                    <template v-slot:first>
                        <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                        <b-form-select-option value=-1>Semua</b-form-select-option>
                    </template>
                </b-form-select>
                <multiselect v-model="filter.tipe"
                    class="mr-2"
                    :options="optTipe"
                    :allow-empty="true"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Tipe Engine"
                />
                <multiselect v-model="filter.wilayah"
                    class="mr-2"
                    :options="optWilayah"
                    :allow-empty="true"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Wilayah"
                />
                <multiselect v-model="filter.lokasi"
                    class="mr-2"
                    :options="optLokasiSearch"
                    :allow-empty="true"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Lokasi"
                    :disabled="filter.wilayah == null"
                />
                <b-form-select v-model="filter.lokasiStatus" class="mr-2">
                    <template v-slot:first>
                        <b-form-select-option :value="-1">Semua Status Lokasi</b-form-select-option>
                        <b-form-select-option :value="2">DHP</b-form-select-option>
                        <b-form-select-option :value="3">Lainnya</b-form-select-option>
                    </template>
                </b-form-select>
                <b-button variant="primary" @click="getItems">
                    <i class="fa fa-search" />
                </b-button>
                <b-button v-if="isAllowed('download-excel')" class="ml-2" variant="success" @click="$bvModal.show('modal-excel')">
                    <i class="fa fa-download" />
                </b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada engine.
                </template>
                <template v-slot:cell(log)="row">
                    <b-button size="sm" variant="primary" @click="prepareModal(row.item, 'modal-log')">
                        <i class="fa fa-book" />
                    </b-button>
                </template>
                <template v-slot:cell(sn)="row">
                    {{ row.item.sn }} <a class="small" href="#" @click="copyToClipboard(row.item.sn, $event)">[Copy]</a>
                    <div class="small text-muted">{{ row.item.type.name }}</div>
                    <div class="small">{{ row.item.jamOperasional }} J.O - {{ $helper.parseDate(row.item.updateJamOperasional) }}</div>
                </template>
                <template v-slot:cell(lokasi)="row">
                    {{ row.item.lokasi }}
                    <b-badge v-if="row.item.lokasiStatus == 2" variant="dark">DHP</b-badge>
                    <b-badge v-else-if="row.item.lokasiStatus == 3" variant="warning">LAINNYA</b-badge>
                    <div class="small text-muted">{{ row.item.wilayah }}</div>
                    <div v-if="row.item.planToMove != null" class="small">
                        Plan: {{ row.item.planToMove }}
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="parseBadgeVariantTipe(row.item.status.id)">
                        {{ row.item.status.name }}
                    </b-badge>
                </template>
                <template v-slot:cell(topup)="row">
                    <div v-if="row.item.topUpSelanjutnya.name != null">
                        {{ $helper.parseDate(row.item.topUpSelanjutnya.name) }}
                        <div :class="`small ${row.item.topUpSelanjutnya.id >= 0 ? 'text-danger font-weight-bold' : 'text-muted'}`">
                            H{{ row.item.topUpSelanjutnya.id >= 0 ? "+" : "" }}{{ row.item.topUpSelanjutnya.id }}
                        </div>
                        <div :class="`small ${row.item.topUpCount > 2 ? 'text-danger font-weight-bold' : ''}`">
                            # Top Up: {{ row.item.topUpCount }}
                        </div>
                    </div>
                    <div v-else>-</div>
                </template>
                <template v-slot:cell(service)="row">
                    <div v-if="row.item.serviceSelanjutnya.name != null">
                        {{ $helper.parseDate(row.item.serviceSelanjutnya.name) }}
                        <div :class="`small ${row.item.serviceSelanjutnya.id >= 0 ? 'text-danger font-weight-bold' : 'text-muted'}`">
                            H{{ row.item.serviceSelanjutnya.id >= 0 ? "+" : "" }}{{ row.item.serviceSelanjutnya.id }}
                        </div>
                    </div>
                    <div v-else>-</div>
                    <div :class="`small ${row.item.returnOli ? '' : 'text-danger font-weight-bold'}`">
                        {{ row.item.returnOli ? 'Sudah' : 'Belum' }} Return Oli
                    </div>
                </template>
                <template v-slot:cell(action)="row" style="padding-top: 0">
                    <b-button v-if="row.item.hasPendingSpb" size="sm" variant="danger" class="mr-2 mb-2" v-b-tooltip.hover.top title="SPB" @click="openSpbDetail(row.item)">
                        SPB
                    </b-button>
                    <b-button v-if="isAllowed('catatan')" size="sm" variant="primary" class="mr-2 mb-2" v-b-tooltip.hover title="Catatan" @click="prepareModal(row.item, 'modal-catatan')">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button v-if="isAllowed('plan-to-move')" size="sm" variant="primary" class="mr-2 mb-2" v-b-tooltip.hover title="Plan to Move" @click="prepareModal(row.item, 'modal-plan-to-move')">
                        <i class="fa fa-fw fa-map-marker" />
                    </b-button>
                    <b-button v-if="isAllowed('pindah-ready', row.item)" size="sm" variant="dark" class="mr-2 mb-2" v-b-tooltip.hover title="Pindah" @click="prepareModal(row.item, 'modal-pindah-ready')">
                        <i class="fa fa-fw fa-truck" />
                    </b-button>
                    <b-button v-if="isAllowed('pindah-active', row.item)" size="sm" variant="warning" class="mr-2 mb-2" v-b-tooltip.hover title="Retur" @click="prepareModal(row.item, 'modal-pindah-active')">
                        <i class="fa fa-fw fa-truck" />
                    </b-button>
                    <b-button v-if="isAllowed('pindah-repair-retur', row.item)" size="sm" variant="dark" class="mr-2 mb-2" v-b-tooltip.hover title="Pindah" @click="prepareModal(row.item, 'modal-pindah-repair-retur')">
                        <i class="fa fa-fw fa-truck" />
                    </b-button>
                    <b-button v-if="isAllowed('topup', row.item)" size="sm" variant="success" class="mr-2 mb-2" v-b-tooltip.hover title="Top Up" @click="prepareModal(row.item, 'modal-topup')">
                        <i class="fa fa-fw fa-plus" />
                    </b-button>
                    <b-button v-if="isAllowed('service', row.item)" size="sm" variant="success" class="mr-2 mb-2" v-b-tooltip.hover title="Service" @click="prepareModal(row.item, 'modal-service')">
                        <i class="fa fa-fw fa-wrench" />
                    </b-button>
                    <b-button v-if="isAllowed('set-ready', row.item)" size="sm" variant="success" class="mr-2 mb-2" v-b-tooltip.hover title="Set Ready Line" @click="prepareModal(row.item, 'modal-set-ready')">
                        <i class="fa fa-fw fa-check" />
                    </b-button>
                    <!-- <b-button v-if="isAllowed('repair', row.item)" size="sm" variant="dark" class="mr-2 mb-2" v-b-tooltip.hover title="Repair" @click="prepareModal(row.item, 'modal-repair')">
                        <i class="fa fa-fw fa-wrench" />
                    </b-button>
                    <b-button v-if="isAllowed('overhaul', row.item)" size="sm" variant="danger" class="mr-2 mb-2" v-b-tooltip.hover title="Overhaul" @click="prepareModal(row.item, 'modal-overhaul')">
                        <i class="fa fa-fw fa-cog" />
                    </b-button> -->
                    <b-button v-if="isAllowed('set-active', row.item)" size="sm" variant="success" class="mr-2 mb-2" v-b-tooltip.hover title="Set Installed" @click="prepareModal(row.item, 'modal-set-active')">
                        <i class="fa fa-fw fa-flag" />
                    </b-button>
                    <b-button v-if="isAllowed('return-oli', row.item)" size="sm" variant="success" class="mr-2 mb-2" v-b-tooltip.hover title="Return Oli" @click="prepareModal(row.item, 'modal-return-oli')">
                        <i class="fa fa-fw fa-refresh" />
                    </b-button>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                    @change="onPageChange"
                />
            </div>
        </b-card>
        <b-modal id="modal-catatan" title="Tambah Catatan"
            centered no-close-on-backdrop no-close-on-esc hide-footer
        >
            Pencatatan untuk Engine <b>{{ activeItem.sn }}</b>
            <br /><br />
            <b-form-group label-cols-sm="3" label-cols-lg="4" label="Tanggal Pengerjaan" label-for="i1">
                <b-form-input id="i1" type="date" v-model="input.tanggalPergerjaan" :max="maxDate" />
            </b-form-group>
            <b-form-group label-cols-sm="3" label-cols-lg="4" label="Tipe Catatan">
                <b-form-select v-model="input.tipeCatatan" :options="optTipeCatatan" />
            </b-form-group>
            <div v-if="input.tipeCatatan == 1">
                <b-form-textarea
                    ref="inputCatatan"
                    v-model="input.catatan"
                    placeholder="Tulis catatan anda..."
                    rows="6"
                    max-rows="6"
                    :maxlength="keteranganMaxLength"
                />
                <div class="text-right small text-muted mb-3">{{ input.catatan.length }} / {{ keteranganMaxLength }}</div>
            </div>
            <div v-else-if="input.tipeCatatan == 2">
                <b-form-group label-cols-sm="3" label-cols-lg="4" label="Jam Operasional">
                    <b-form-input type="number" v-model="input.jamOperasional" />
                </b-form-group>
            </div>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeInsertCatatan">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-pindah-ready" title="Perpindahan"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.inputPerpindahanReady.focus()"
        >
            Perpindahan untuk Engine <b>{{ activeItem.sn }}</b>
            <br />
            Lokasi Sekarang: {{ activeItem.wilayah }}, {{ activeItem.lokasi }}
            <br />
            Plan to Move sekarang: {{ activeItem.planToMove || "Tidak ada" }}
            <b-form-group label="Tanggal Pengerjaan" label-for="i1" class="mt-3">
                <b-form-input id="i1" type="date" v-model="input.tanggalPergerjaan" :max="maxDate" />
            </b-form-group>
            <b-row class="mt-3 mb-3">
                <b-col>
                    <multiselect v-model="input.wilayah"
                        :options="optWilayah"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Wilayah"
                    />
                </b-col>
                <b-col>
                    <multiselect v-model="input.lokasi"
                        :options="optLokasi"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Lokasi"
                        :disabled="input.wilayah == null"
                    />
                </b-col>
            </b-row>
            <b-form-textarea
                ref="inputPerpindahanReady"
                v-model="input.catatan"
                placeholder="Tulis catatan anda..."
                rows="3"
                max-rows="3"
                :maxlength="keteranganMaxLength"
            />
            <div class="text-right small text-muted mb-3">{{ input.catatan.length }} / {{ keteranganMaxLength }}</div>
            <b-alert variant="primary" show>
                <div class="font-weight-bold">INFORMASI</div>
                Pemindahan engine ke WORKSHOP akan mengubah status engine menjadi REPAIR!
            </b-alert>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executePerpindahanReady">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-pindah-active" title="Retur"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.inputPerpindahanActive.focus()"
        >
            Retur untuk Engine <b>{{ activeItem.sn }}</b>
            <br />
            Lokasi Sekarang: {{ activeItem.wilayah }}, {{ activeItem.lokasi }}
            <br />
            Plan to Move sekarang: {{ activeItem.planToMove || "Tidak ada" }}
            <b-form-group label="Tanggal Pengerjaan" label-for="i1" label-cols-sm="3" label-cols-lg="4" class="mt-3">
                <b-form-input id="i1" type="date" v-model="input.tanggalPergerjaan" :max="maxDate" />
            </b-form-group>
            <b-form-group label="Warehouse Tujuan" label-cols-sm="3" label-cols-lg="4">
                <multiselect v-model="input.lokasi"
                    :options="optWarehouse"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Warehouse"
                />
            </b-form-group>
            <b-form-textarea
                ref="inputPerpindahanActive"
                v-model="input.catatan"
                placeholder="Tulis catatan anda..."
                rows="3"
                max-rows="3"
                :maxlength="keteranganMaxLength"
            />
            <div class="text-right small text-muted mb-3">{{ input.catatan.length }} / {{ keteranganMaxLength }}</div>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executePerpindahanActive">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-pindah-repair-retur" title="Perpindahan"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.inputPerpindahanRepairRetur.focus()"
        >
            Perpindahan untuk Engine <b>{{ activeItem.sn }}</b>
            <br />
            Lokasi Sekarang: {{ activeItem.wilayah }}, {{ activeItem.lokasi }}
            <br />
            Plan to Move sekarang: {{ activeItem.planToMove || "Tidak ada" }}
            <b-form-group label="Tanggal Pengerjaan" label-for="i1" class="mt-3">
                <b-form-input id="i1" type="date" v-model="input.tanggalPergerjaan" :max="maxDate" />
            </b-form-group>
            <b-row class="mt-3 mb-3">
                <b-col>
                    <b-form-select v-model="input.tipeLokasi">
                        <b-form-select-option value="-1" disabled>Tipe Lokasi</b-form-select-option>
                        <b-form-select-option value="0">WORKSHOP</b-form-select-option>
                        <b-form-select-option value="3">WAREHOUSE</b-form-select-option>
                    </b-form-select>
                </b-col>
                <b-col>
                    <multiselect v-model="input.lokasi"
                        :options="optLokasi"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Lokasi"
                        :disabled="input.tipeLokasi == -1"
                    />
                </b-col>
            </b-row>
            <b-form-textarea
                ref="inputPerpindahanRepairRetur"
                v-model="input.catatan"
                placeholder="Tulis catatan anda..."
                rows="3"
                max-rows="3"
                :maxlength="keteranganMaxLength"
            />
            <div class="text-right small text-muted mb-3">{{ input.catatan.length }} / {{ keteranganMaxLength }}</div>
            <b-alert variant="primary" show>
                <div class="font-weight-bold">INFORMASI</div>
                Pemindahan engine berstatus RETUR ke WORKSHOP akan mengubah status engine menjadi REPAIR!
            </b-alert>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executePerpindahanRepairRetur">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-set-active" title="Konfirmasi Set Installed"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.inputSetActive.focus()"
        >
            Pengubahan status Engine <b>{{ activeItem.sn }}</b> menjadi <b>INSTALLED</b>.
            <br /><br />
            <b-form-group label="Tanggal Pengerjaan" label-for="i1">
                <b-form-input id="i1" type="date" v-model="input.tanggalPergerjaan" :max="maxDate" />
            </b-form-group>
            <b-form-textarea
                ref="inputSetActive"
                v-model="input.catatan"
                placeholder="Tulis catatan anda..."
                rows="6"
                max-rows="6"
                :maxlength="keteranganMaxLength"
            />
            <div class="text-right small text-muted mb-3">{{ input.catatan.length }} / {{ keteranganMaxLength }}</div>
            <div class="mt-2 text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeSetActive">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-set-ready" title="Konfirmasi Set Ready Line"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.inputSetReady.focus()"
        >
            Pengubahan status Engine <b>{{ activeItem.sn }}</b> menjadi <b>READY LINE</b>.
            <br /><br />
            <b-form-group label="Tanggal Pengerjaan" label-for="i1">
                <b-form-input id="i1" type="date" v-model="input.tanggalPergerjaan" :max="maxDate" />
            </b-form-group>
            <b-form-textarea
                ref="inputSetReady"
                v-model="input.catatan"
                placeholder="Tulis catatan anda..."
                rows="6"
                max-rows="6"
                :maxlength="keteranganMaxLength"
            />
            <div class="text-right small text-muted mb-3">{{ input.catatan.length }} / {{ keteranganMaxLength }}</div>
            <div class="mt-2 text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeSetReady">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-topup" title="Top Up Engine"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.inputTopup.focus()"
        >
            Top Up untuk Engine <b>{{ activeItem.sn }}</b>
            <br /><br />
            <b-form-group label="Tanggal Pengerjaan" label-for="i1">
                <b-form-input id="i1" type="date" v-model="input.tanggalPergerjaan" :max="maxDate" />
            </b-form-group>
            <b-form-textarea
                ref="inputTopup"
                v-model="input.catatan"
                placeholder="Tulis catatan anda..."
                rows="6"
                max-rows="6"
                :maxlength="keteranganMaxLength"
            />
            <div class="text-right small text-muted mb-3">{{ input.catatan.length }} / {{ keteranganMaxLength }}</div>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeTopUp">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-service" title="Service Engine"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.inputService.focus()"
        >
            Service untuk Engine <b>{{ activeItem.sn }}</b>
            <br /><br />
            <b-form-group label="Tanggal Pengerjaan" label-for="i1">
                <b-form-input id="i1" type="date" v-model="input.tanggalPergerjaan" :max="maxDate" />
            </b-form-group>
            <b-form-textarea
                ref="inputService"
                v-model="input.catatan"
                placeholder="Tulis catatan anda..."
                rows="6"
                max-rows="6"
                :maxlength="keteranganMaxLength"
            />
            <div class="text-right small text-muted mb-3">{{ input.catatan.length }} / {{ keteranganMaxLength }}</div>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeService">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-repair" title="Repair Engine"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.inputRepair.focus()"
        >
            Repair untuk Engine <b>{{ activeItem.sn }}</b>
            <br /><br />
            <b-form-group label="Tanggal Pengerjaan" label-for="i1">
                <b-form-input id="i1" type="date" v-model="input.tanggalPergerjaan" :max="maxDate" />
            </b-form-group>
            <b-form-textarea
                ref="inputRepair"
                v-model="input.catatan"
                placeholder="Tulis catatan anda..."
                rows="6"
                max-rows="6"
                :maxlength="keteranganMaxLength"
            />
            <div class="text-right small text-muted mb-3">{{ input.catatan.length }} / {{ keteranganMaxLength }}</div>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeRepair">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-overhaul" title="Overhaul Engine"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.inputOverhaul.focus()"
        >
            Overhaul untuk Engine <b>{{ activeItem.sn }}</b>
            <br /><br />
            <b-form-group label="Tanggal Pengerjaan" label-for="i1">
                <b-form-input id="i1" type="date" v-model="input.tanggalPergerjaan" :max="maxDate" />
            </b-form-group>
            <b-form-textarea
                ref="inputOverhaul"
                v-model="input.catatan"
                placeholder="Tulis catatan anda..."
                rows="6"
                max-rows="6"
                :maxlength="keteranganMaxLength"
            />
            <div class="text-right small text-muted mb-3">{{ input.catatan.length }} / {{ keteranganMaxLength }}</div>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeOverhaul">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-return-oli" title="Return Oli"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.inputReturnOli.focus()"
        >
            Return Oli untuk Engine <b>{{ activeItem.sn }}</b>
            <br /><br />
            <b-form-group label="Tanggal Pengerjaan" label-for="i1">
                <b-form-input id="i1" type="date" v-model="input.tanggalPergerjaan" :max="maxDate" />
            </b-form-group>
            <b-form-textarea
                ref="inputReturnOli"
                v-model="input.catatan"
                placeholder="Tulis catatan anda..."
                rows="6"
                max-rows="6"
                :maxlength="keteranganMaxLength"
            />
            <div class="text-right small text-muted mb-3">{{ input.catatan.length }} / {{ keteranganMaxLength }}</div>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeReturnOli">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-plan-to-move" title="Plan to Move"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @hidden="input.lokasiMode = 0"
        >
            Plan to Move untuk Engine <b>{{ activeItem.sn }}</b>
            <br />
            Lokasi Sekarang: {{ activeItem.wilayah }}, {{ activeItem.lokasi }}
            <br />
            Plan to Move sekarang: {{ activeItem.planToMove || "Tidak ada" }}
            <b-row class="mt-3 mb-2">
                <b-col>
                    <multiselect v-model="input.wilayah"
                        :options="optWilayah"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Wilayah"
                        :disabled="isCancellingPlanToMove"
                    />
                </b-col>
                <b-col>
                    <multiselect v-model="input.lokasi"
                        :options="optLokasi"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Lokasi"
                        :disabled="input.wilayah == null || isCancellingPlanToMove"
                    />
                </b-col>
            </b-row>
            <b-form-checkbox v-if="activeItem.planToMove != null" v-model="isCancellingPlanToMove" class="mb-2">Batalkan Plan to Move</b-form-checkbox>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executePlanToMove">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-excel" title="Cetak Excel" centered no-close-on-esc no-close-on-backdrop hide-footer @hidden="printStatus = 0">
            <div v-if="printStatus == 0">
                <div>
                    <b-button variant="success" @click="executeDownloadExcelEngine">Download Excel Engine List</b-button>
                </div>
                <hr />
                <div>
                    <b-input-group>
                        <b-form-input type="date" v-model="tanggalInputExcel" :max="maxDate" />
                        <b-input-group-append>
                            <b-button variant="success" @click="executeDownloadExcelLog">Download Excel Log List</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <div v-else-if="printStatus == 1" class="text-center">
                <b-spinner class="loading-spinner" variant="dark"></b-spinner>
                <div class="mt-2">Mohon menunggu...</div>
            </div>
            <div v-else-if="printStatus == 2">
                <div class="mb-2">Excel siap didownload, silahkan klik tombol dibawah ini:</div>
                <a :href="excelPath" download>
                    <b-button variant="primary">
                        <i class="fa fa-download mr-2" />Download Excel
                    </b-button>
                </a>
            </div>
        </b-modal>
        <b-modal id="modal-spb" no-close-on-esc hide-footer no-close-on-backdrop title="SPB Pending">
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                SPB pending untuk <strong>{{ activeItem.sn }}</strong>:
                <ul>
                    <li v-for="spb in spbs" v-bind:key="spb">{{ spb }}</li>
                </ul>
            </div>
        </b-modal>
        <LogModal :main="activeItem" :title="logTitle" @should-refresh="shouldRefresh" />
    </div>
</template>

<script>
import LogModal from '@/views/logs/Logs'

export default {
    name: 'dashboard-engine',
    components: { LogModal },
    data() {
        return {

            keteranganMaxLength: 1000,
            roleId: 1,
            maxDate: "",

            spbs: [],

            isBusy: true,
            isSubmitting: false,

            printStatus: 0,
            excelPath: "",
            tanggalInputExcel: "",

            filter: {
                sn: "",
                tipe: null,
                wilayah: null,
                lokasi: null,
                status: -1,
                mode: 0,
                lokasiStatus: -1
            },

            input: {
                tipeCatatan: 1, // 1 -> Catatan umum, 2 -> Jam operasional
                tipeLokasi: -1, // 0 -> Workshop, 3 -> warehouse
                jamOperasional: null,
                catatan: "",
                tanggalPergerjaan: "",
                wilayah: null,
                lokasi: null,
                tipePindah: 1, // 1 -> Repair, 2 -> Retur,
                lokasiMode: 0 // 0: limited, 1: find all
            },

            isCancellingPlanToMove: false,

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "log", label: "Log" },
                { key: "sn", label: "SN & Tipe" },
                { key: "status", label: "Status" },
                { key: "lokasi", label: "Lokasi" },
                { key: "topup", label: "Next Topup" },
                { key: "service", label: "Next Service" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                wilayah: "",
                lokasi: ""
            },
            logTitle: "",

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optTipe: [],
            optWilayah: [],
            optLokasi: [],
            optLokasiSearch: [],
            optWarehouse: [],
            optStatus: [
                { value: 0, text: "Ready Line" },
                { value: 1, text: "Installed" },
                { value: 2, text: "Repair" },
                { value: 3, text: "Shipment" },
                { value: 4, text: "Retur" },
                { value: 99, text: "Lainnya" }
            ],
            optMode: [
                { value: 0, text: "Pencarian Standard" },
                { value: 1, text: "Mendekati Jadwal Top Up (H-3 Keatas)" },
                { value: 2, text: "Mendekati Jadwal Service (H-3 Keatas)" },
                { value: 3, text: "Over Top Up (# Top Up melebihi 2)" },
                { value: 4, text: "Belum Return Oli" }
            ],
            optTipeCatatan: [
                { value: 1, text: "Pencatatan Umum" },
                { value: 2, text: "Jam Operasional" }
            ],
            optTipePindah: [
                { value: 1, text: "Repair" },
                { value: 2, text: "Cabut Habis / Retur" }
            ]

        }
    },
    methods: {

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)
            param += "&mode=" + this.filter.mode

            if(!this.$helper.isBlank(this.filter.sn)) {
                param += "&filterSn=" + this.filter.sn
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(!this.$helper.isBlank(this.filter.lokasi)) {
                param += "&filterLokasi=" + this.filter.lokasi.id
            }
            else if(!this.$helper.isBlank(this.filter.wilayah)) {
                param += "&filterWilayah=" + this.filter.wilayah.id
            }

            if(!this.$helper.isBlank(this.filter.tipe)) {
                param += "&filterType=" + this.filter.tipe.id
            }

            if(this.filter.lokasiStatus != -1) {
                param += "&filterLokasiStatus=" + this.filter.lokasiStatus
            }

            // Execute
            this.$axios.get("engine/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        parseBadgeVariantTipe(id) {
            switch(id) {
                case 0: return "dark"
                case 1: return "success"
                case 2: return "danger"
                case 3: return "primary"
                case 4: return "warning"
                default: return "light"
            }
        },

        // ===== API Actionable Engines
        prepareModal(item, modalId) {

            if(modalId == "modal-pindah-active" && this.optWarehouse.length == 0) {

                this.$axios.get("lokasi/warehouse").then(res => {
                    this.optWarehouse = res.data
                })

            }

            console.log(modalId)
            if(modalId == "modal-plan-to-move") {
                this.input.lokasiMode = 1
            }
            else {
                this.input.lokasiMode = 0
            }

            this.activeItem = item
            this.logTitle = item.sn
            this.$bvModal.show(modalId)

        },

        executeInsertCatatan() {

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)
            payload.append("tanggalPengerjaan", this.input.tanggalPergerjaan)

            if(this.input.tipeCatatan == 1) {

                payload.append("catatan", this.input.catatan)

                this.isSubmitting = true
                this.$axios.post("log/catatan", payload).then(res => {

                    if(res.data.id == 1) {
                        this.$helper.toastSuccess(this, "Catatan berhasil disimpan!")
                        this.input.catatan = ""
                        this.$bvModal.hide("modal-catatan")
                    }

                })
                .catch(error => { this.$helper.parseError(this, error) })
                .finally(() => { this.isSubmitting = false })

            }
            else {

                // Cek validitas input
                if(this.$helper.isBlank(this.input.jamOperasional)) {
                    return this.$helper.toastError(this, "Jam operasional harus diisi!")
                }

                if(this.input.jamOperasional < 0) {
                    return this.$helper.toastError(this, "Jam operasional tidak boleh negatif!")
                }

                if(this.input.jamOperasional % 1 != 0) {
                    return this.$helper.toastError(this, "Jam operasional harus bilangan bulat!")
                }

                payload.append("jamOperasional", this.input.jamOperasional)

                this.isSubmitting = true
                this.$axios.post("engine/jam-operasional", payload).then(res => {

                    if(res.data.id == 1) {
                        this.$helper.toastSuccess(this, "Catatan berhasil disimpan!")
                        this.input.jamOperasional = null
                        this.activeItem.jamOperasional = payload.get("jamOperasional")
                        this.$bvModal.hide("modal-catatan")
                    }

                })
                .catch(error => { this.$helper.parseError(this, error) })
                .finally(() => { this.isSubmitting = false })

            }

        },

        executePerpindahanReady() {

            if(this.input.lokasi == null) {
                return this.$helper.toastError(this, "Mohon pilih lokasi perpindahan!")
            }

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)
            payload.append("lokasiId", this.input.lokasi.id)
            payload.append("tanggalPengerjaan", this.input.tanggalPergerjaan)
            payload.append("catatan", this.input.catatan)

            this.isSubmitting = true
            this.$axios.post("engine/pindah-ready", payload).then(res => {

                if(res.data.id == 1) {

                    this.$helper.toastSuccess(this, "Engine berhasil dipindahkan!")
                    this.$bvModal.hide("modal-pindah-ready")

                    this.input.catatan = ""
                    this.input.wilayah = null
                    this.input.lokasi = null

                    this.getItems()

                }

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executePerpindahanActive() {

            if(this.input.lokasi == null) {
                return this.$helper.toastError(this, "Mohon pilih lokasi perpindahan!")
            }

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)
            payload.append("lokasiId", this.input.lokasi.id)
            payload.append("tanggalPengerjaan", this.input.tanggalPergerjaan)
            // payload.append("tipePemindahan", this.input.tipePindah)
            payload.append("catatan", this.input.catatan)

            this.isSubmitting = true
            this.$axios.post("engine/pindah-aktif", payload).then(res => {

                if(res.data.id == 1) {

                    this.$helper.toastSuccess(this, "Engine berhasil diretur!")
                    this.$bvModal.hide("modal-pindah-active")

                    this.input.catatan = ""
                    this.input.wilayah = null
                    this.input.lokasi = null

                    this.getItems()

                }

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executePerpindahanRepairRetur() {

            if(this.input.lokasi == null) {
                return this.$helper.toastError(this, "Mohon pilih lokasi perpindahan!")
            }

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)
            payload.append("lokasiId", this.input.lokasi.id)
            payload.append("tanggalPengerjaan", this.input.tanggalPergerjaan)
            payload.append("catatan", this.input.catatan)

            this.isSubmitting = true
            this.$axios.post("engine/pindah-repair-retur", payload).then(res => {

                if(res.data.id == 1) {

                    this.$helper.toastSuccess(this, "Engine berhasil dipindahkan!")
                    this.$bvModal.hide("modal-pindah-repair-retur")

                    this.input.catatan = ""
                    this.input.wilayah = null
                    this.input.lokasi = null

                    this.getItems()

                }

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeSetActive() {

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)
            payload.append("tanggalPengerjaan", this.input.tanggalPergerjaan)
            payload.append("catatan", this.input.catatan)

            this.isSubmitting = true
            this.$axios.post("engine/set-active", payload).then(res => {

                if(res.data.id == 1) {

                    this.$helper.toastSuccess(this, "Engine berhasil diaktifkan!")
                    this.$bvModal.hide("modal-set-active")

                    this.input.catatan = ""
                    this.getItems()

                }

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeSetReady() {

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)
            payload.append("tanggalPengerjaan", this.input.tanggalPergerjaan)
            payload.append("catatan", this.input.catatan)

            this.isSubmitting = true
            this.$axios.post("engine/set-ready", payload).then(res => {

                if(res.data.id == 1) {

                    this.$helper.toastSuccess(this, "Engine berhasil disiapkan!")
                    this.$bvModal.hide("modal-set-ready")

                    this.input.catatan = ""
                    this.getItems()

                }

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeTopUp() {

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)
            payload.append("tanggalPengerjaan", this.input.tanggalPergerjaan)
            payload.append("catatan", this.input.catatan)

            this.isSubmitting = true
            this.$axios.post("engine/topup", payload).then(res => {

                if(res.data.id == 1) {

                    this.$helper.toastSuccess(this, "Engine berhasil di-topup!")
                    this.$bvModal.hide("modal-topup")

                    this.input.catatan = ""
                    this.getItems()

                }

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeService() {

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)
            payload.append("tanggalPengerjaan", this.input.tanggalPergerjaan)
            payload.append("catatan", this.input.catatan)

            this.isSubmitting = true
            this.$axios.post("engine/service", payload).then(res => {

                if(res.data.id == 1) {

                    this.$helper.toastSuccess(this, "Engine berhasil diservice!")
                    this.$bvModal.hide("modal-service")

                    this.input.catatan = ""
                    this.getItems()

                }

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeRepair() {

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)
            payload.append("tanggalPengerjaan", this.input.tanggalPergerjaan)
            payload.append("catatan", this.input.catatan)

            this.isSubmitting = true
            this.$axios.post("engine/repair", payload).then(res => {

                if(res.data.id == 1) {

                    this.$helper.toastSuccess(this, "Engine berhasil direpair!")
                    this.$bvModal.hide("modal-repair")

                    this.input.catatan = ""
                    this.getItems()

                }

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeOverhaul() {

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)
            payload.append("tanggalPengerjaan", this.input.tanggalPergerjaan)
            payload.append("catatan", this.input.catatan)

            this.isSubmitting = true
            this.$axios.post("engine/overhaul", payload).then(res => {

                if(res.data.id == 1) {

                    this.$helper.toastSuccess(this, "Engine berhasil dioverhaul!")
                    this.$bvModal.hide("modal-overhaul")

                    this.input.catatan = ""
                    this.getItems()

                }

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeReturnOli() {

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)
            payload.append("tanggalPengerjaan", this.input.tanggalPergerjaan)
            payload.append("catatan", this.input.catatan)

            this.isSubmitting = true
            this.$axios.post("engine/return-oli", payload).then(res => {

                if(res.data.id == 1) {

                    this.$helper.toastSuccess(this, "Return oli berhasil dicatat!")
                    this.$bvModal.hide("modal-return-oli")

                    this.input.catatan = ""
                    this.getItems()

                }

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executePlanToMove() {

            let payload = new FormData()
            payload.append("engineId", this.activeItem.id)

            if(!this.isCancellingPlanToMove) {

                if(this.input.lokasi == null) {
                    return this.$helper.toastError(this, "Mohon pilih lokasi plan to move!")
                }

                payload.append("lokasiId", this.input.lokasi.id)

            }

            this.isSubmitting = true
            this.$axios.post("engine/plan-to-move", payload).then(res => {

                if(res.data.id == 1) {

                    this.$helper.toastSuccess(this, "Plan to move berhasil diubah!")
                    this.$bvModal.hide("modal-plan-to-move")

                    this.input.catatan = ""
                    this.input.wilayah = null
                    this.input.lokasi = null
                    this.isCancellingPlanToMove = false

                    this.getItems()

                }

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        shouldRefresh() {
            this.getItems(this.currentPage)
        },

        executeDownloadExcelEngine() {

            let param = "?mode=1"

            if(!this.$helper.isBlank(this.filter.sn)) {
                param += "&filterSn=" + this.filter.sn
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(!this.$helper.isBlank(this.filter.lokasi)) {
                param += "&filterLokasi=" + this.filter.lokasi.id
            }
            else if(!this.$helper.isBlank(this.filter.wilayah)) {
                param += "&filterWilayah=" + this.filter.wilayah.id
            }

            if(!this.$helper.isBlank(this.filter.tipe)) {
                param += "&filterType=" + this.filter.tipe.id
            }

            if(this.filter.lokasiStatus != -1) {
                param += "&filterLokasiStatus=" + this.filter.lokasiStatus
            }

            // Execute
            this.printStatus = 1
            this.$axios.get("engine/excel" + param).then(res => {

                this.excelPath = this.$BASE_FILE_PATH + res.data
                this.printStatus = 2

            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.printStatus = 0
            })

        },

        executeDownloadExcelLog() {

            // Execute
            this.printStatus = 1
            this.$axios.get("log/excel-all-engine?tanggal=" + this.tanggalInputExcel).then(res => {

                this.excelPath = this.$BASE_FILE_PATH + res.data
                this.printStatus = 2

            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.printStatus = 0
            })

        },

        openSpbDetail(item) {
            this.$bvModal.show("modal-spb")

            this.isSubmitting = true
            this.activeItem = item

            this.$axios.get("engine/pending-spb/" + this.activeItem.id).then(res => [
                this.spbs = res.data
            ])
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        isAllowed(section, item = { wilayah: { id: -1 } } ) {

            // ROLE-ID
            // 1 -> Logistik
            // 2 -> Ops
            // 3 -> Engine Shop
            // 4 -> Visitor
            // 8 -> Logistik Pusat

            let wilayahId = localStorage.getItem("wilayahId")

            switch(section) {

                case "pindah-ready":
                return this.isRoleAllowed([1, 8])
                    && item.status.id == 0
                    && (this.roleId == 0 || item.wilayahId == wilayahId)

                case "set-active":
                return this.isRoleAllowed([2])
                    && item.status.id == 3
                    && (this.roleId == 0 || item.wilayahId == wilayahId)

                case "pindah-active":
                return this.isRoleAllowed([1, 8])
                    && item.status.id == 1
                    && (this.roleId == 0 || item.wilayahId == wilayahId)

                case "topup":
                return this.isRoleAllowed([2])
                    && item.status.id == 1
                    && (this.roleId == 0 || item.wilayahId == wilayahId)

                case "service":
                return this.isRoleAllowed([2])
                    && item.status.id == 1
                    && (this.roleId == 0 || item.wilayahId == wilayahId)

                case "set-ready":
                return this.isRoleAllowed([1, 8])
                    && [4].includes(item.status.id)
                    && (this.roleId == 0 || item.wilayahId == wilayahId)

                case "repair":
                return this.isRoleAllowed([3])
                    && [2, 4].includes(item.status.id)
                    && (this.roleId == 0 || item.wilayahId == wilayahId)

                case "overhaul":
                return this.isRoleAllowed([3])
                    && item.status.id == 2
                    && (this.roleId == 0 || item.wilayahId == wilayahId)

                case "return-oli":
                return this.isRoleAllowed([1, 8])
                    && !item.returnOli
                    && (this.roleId == 0 || item.wilayahId == wilayahId)

                case "pindah-repair-retur":
                return this.isRoleAllowed([1, 8])
                    && [4].includes(item.status.id)
                    && (this.roleId == 0 || item.wilayahId == wilayahId)

                case "plan-to-move": return this.isRoleAllowed([1, 8])
                case "catatan": return this.roleId != 4
                case "download-excel": return this.roleId == 0

                default: return false

            }

        },

        isRoleAllowed(roles) {
            let allowed = [0, ...roles]
            return allowed.includes(this.roleId)
        },

        copyToClipboard(sn, e) {
            e.preventDefault()

            navigator.clipboard.writeText(sn).then(res =>
                this.$helper.toastSuccess(this, "SN tercopy ke clipboard anda!")
            )
            .catch(error => this.$helper.toastError(this, "Gagal mengcopy, browser anda tidak mensupport copy tulisan!"))
        },

    },
    watch: {

        "input.wilayah": function(newVal) {

            if(newVal == null) { return }

            let append = ""
            if(this.input.lokasiMode == 1) {
                append = "?all=true"
            }

            this.$axios.get("lokasi/selection/" + newVal.id + append).then(res => {
                this.optLokasi = res.data
                this.input.lokasi = null
            })

        },

        "input.tipeLokasi": function(newVal) {

            this.optLokasi = []
            if(newVal == null) { return }

            this.$axios.get("lokasi/selection-by-type/" + newVal).then(res => {
                this.optLokasi = res.data
                this.input.lokasi = null
            })

        },

        "filter.wilayah": function(newVal) {

            this.filter.lokasi = null

            if(newVal == null) {
                return
            }

            let append = ""
            if([0, 7, 8, 10].includes(this.roleId)) {
                append = "?all=true"
            }

            this.$axios.get("lokasi/selection/" + newVal.id + append).then(res => {
                this.optLokasiSearch = res.data
            })

        }

    },
    created() {

        this.roleId = Number(localStorage.getItem("roleId"))

        this.getItems()

        this.$axios.get("wilayah/selection?all=true").then(res => {
            this.optWilayah = res.data
        })

        this.$axios.get("engine-type/selection").then(res => {
            this.optTipe = res.data
        })

        // Pasang tanggal pengerjaan ke hari ini
        let today = new Date()
        today.setHours(today.getHours() + 7)
        let maxDate = today.toISOString().substring(0, 10)

        this.input.tanggalPergerjaan = maxDate
        this.tanggalInputExcel = maxDate
        this.maxDate = maxDate

    }
}
</script>
